import { render, staticRenderFns } from "./search-pagination.vue?vue&type=template&id=7aa2917f"
import script from "./search-pagination.vue?vue&type=script&lang=ts"
export * from "./search-pagination.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports